import Vue from 'vue';
import App from './App';
import router from './router';
import {store} from './store';
import Typograf from 'typograf';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueValidate from 'vee-validate'
import {dictionary} from './validate';
import ShareLink from './tools/share';
import Helpers from '@/tools/Helpers.js'

import "./assets/scss/app.scss";

Vue.use(VueValidate, {
    locale: 'ru',
    dictionary: {
        en: dictionary.en,
        ru: dictionary.ru
    }
});
Vue.use(VueAwesomeSwiper);
let Tp = new Typograf({locale: ['ru', 'en-US']});
Vue.directive('typograph', {
    bind: (el, binding, vnode) => {
        el.innerHTML = Tp.execute(el.innerHTML)
    }
});

Vue.use(ShareLink);


Vue.config.productionTip = false;

new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    data() {
      return {
          helpers: Helpers,
          isMobile: Helpers.isMobile(),
      }
    },
    created() {
        window.vue = this;
    },
    mounted() {
            let classList = document.getElementById('app').classList;
            let mClassName = 'mobile';
            if (Helpers.isMobile()) {
                classList.add(mClassName);
                this.isMobile = true;
                console.log('mobile');
            } else {
                classList.remove(mClassName);
                this.isMobile = false;
            }
    },
    components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js